import { type ReportsTranslations } from './reports.translations.pl.ts';

export const reportsTranslations: ReportsTranslations = {
  contents: 'Contents',
  dashboardPdf: {
    button: 'Print / save as PDF',
    contents:
      'Key figures and funnel · map of voivodeships · candidate inflow · quiz results · skills',
    description:
      'The charts, the map and the key recruitment figures, ready to print or save as a PDF and pass on.',
    hint: 'In the print dialog, choose "Save as PDF".',
    scope: 'Dashboard for the selected period',
    title: 'Dashboard as PDF',
  },
  downloadError: 'An error occurred while downloading the report. Please try again.',
  formats: {
    excel: 'Excel',
    pdf: 'PDF',
  },
  fullExport: {
    contents: 'Form data · quiz score and status · consents · a separate sheet with skills',
    description:
      'Everything we know about the candidates. A large file is prepared in the background: you can close the tab and it will download when you come back to the panel.',
    downloadFailed: 'Could not download the generated file. Please try again.',
    downloading: 'Downloading the generated file…',
    generating: 'Preparing the file in the background…',
    retry: 'Try again',
    scope: 'Candidates registered in the selected period',
    start: 'Prepare Excel',
    startFailed: 'Could not start the export. Please try again.',
    stopTracking: 'Stop tracking',
    title: 'Full candidates export',
  },
  heading: 'Reports',
  period: {
    all: 'Whole recruitment',
    custom: 'Custom period',
    days30: '30 days',
    days7: '7 days',
    days90: '90 days',
    from: 'From',
    invalid: 'The start date cannot be later than the end date.',
    label: 'Period of the reports',
    sinceStart: 'Since the recruitment started',
    to: 'To',
  },
  quizResults: {
    button: 'Download Excel',
    contents: 'E-mail address · points · date the quiz was finished',
    description: 'The candidates who finished the quiz, with the points they scored.',
    scope: 'Quizzes finished in the selected period',
    title: 'Quiz results',
  },
  subtitle:
    'Recruitment data for Excel and a print-ready dashboard: for the whole recruitment or a selected period',
  summary: {
    candidates: 'Registered candidates',
    hint: 'Candidates registered in this period, counted as on the dashboard.',
    quizzesFinished: 'Finished the quiz',
    recommended: 'Recommended',
    title: 'In the selected period',
  },
};
